import { jsx as ___EmotionJSX } from "@emotion/core";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import Fade from "./Fade";
export default class LoadFadeIn extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      ready: false
    });
  }

  componentDidMount() {
    this._isMounted = true;
    if (this.state.ready) return;
    const startAt = Date.now();
    const interval = setInterval(() => {
      if (document.readyState === 'complete' && this.props.ready || Date.now() - startAt > this.props.timeout) {
        clearInterval(interval);
        if (this.props.onLoad) this.props.onLoad();
        if (this._isMounted) this.setState({
          ready: true
        });
      }
    }, 50);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const {
      className,
      style
    } = this.props;
    const ready = this.state.ready;
    const hide = ready ? _objectSpread({}, style) : _objectSpread({}, style, {
      maxHeight: '100vh',
      opacity: 0,
      overflow: 'hidden'
    });
    return ___EmotionJSX(Fade, {
      in: ready,
      timeout: 400
    }, ___EmotionJSX("div", {
      className: className,
      style: hide
    }, this.props.children));
  }

}

_defineProperty(LoadFadeIn, "propTypes", {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]).isRequired,
  timeout: PropTypes.number,
  onLoad: PropTypes.func,
  ready: PropTypes.bool
});

_defineProperty(LoadFadeIn, "defaultProps", {
  timeout: 10000,
  ready: true
});